import { IAgreementListFilterExtraField } from '../interfaces/IAgreementListFilterField';

export const initialAgreementListAdditionalFields: IAgreementListFilterExtraField[] = [
  {
    id: 'executionAgreementDateBetween',
    name: 'Срок исполнения соглашения',
    isSelected: false,
    type: 'date',
  },
  {
    id: 'subjectInn',
    name: 'ИНН проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'objectOgrn',
    name: 'ОГРН проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectOrgName',
    name: 'Наименование проверяемого лица',
    isSelected: false,
    type: 'text',
  },
];

export const isTestAdditionalField: IAgreementListFilterExtraField = {
  id: 'isTest',
  name: 'Тестовый',
  isSelected: false,
  type: 'select',
};
